import { createSelector } from 'reselect'

const sessionReducerInstalacionSelector = (state) => {
  return state.sessionReducer.getIn(['instalacion'])
}
export const instalacionSelector = createSelector(
  sessionReducerInstalacionSelector,
  (instalacionField) => {
    // armo el objeto de instalación
    let myInstalacion = {}

    if (instalacionField !== undefined) {
      instalacionField = instalacionField.toJS()

      myInstalacion.id = instalacionField.idInstalacion
      myInstalacion.logoSuperior = instalacionField.logoHorizontal
      myInstalacion.logoFooter = instalacionField.logoFooter
      myInstalacion.logoProducto = instalacionField.logoCard
      myInstalacion.logoDrawer = instalacionField.logoDrawer
      myInstalacion.logoFooter1 = instalacionField.imgPiePagina
      myInstalacion.logoFooter2 = instalacionField.imgPiePagina2
      myInstalacion.fondoLogin = instalacionField.fondoLogin
      myInstalacion.logoLogin = instalacionField.logoLogin
      myInstalacion.logoMail = instalacionField.logoMail
      myInstalacion.iconoMenu = instalacionField.iconoMenu
      myInstalacion.mostrarNombre = instalacionField.mostrarNombre
      myInstalacion.ecommerceNegativo = instalacionField.ecommerceNegativo
      myInstalacion.ecommerceGreyscale = instalacionField.ecommerceGreyscale
      myInstalacion.ecommerceGreyscale2 = instalacionField.ecommerceGreyscale2
      myInstalacion.mediosPagoNoHabilitados = instalacionField.mediosPagoNoHabilitados
      myInstalacion.mediosPagoHabilitados = instalacionField.mediosPagoHabilitados
      myInstalacion.mediosPagoImage = instalacionField.mediosPagoImage
      myInstalacion.mediosPagoHabilitadosImagenes = instalacionField.mediosPagoHabilitadosImagenes
      myInstalacion.mediosPagoNoHabilitadosImagenes = instalacionField.mediosPagoNoHabilitadosImagenes
      myInstalacion.mediosPagohHabilitadosImagenesEliminadas = instalacionField.mediosPagohHabilitadosImagenesEliminadas
      myInstalacion.mediosPagoNoHabilitadosImagenesEliminadas = instalacionField.mediosPagoNoHabilitadosImagenesEliminadas
      myInstalacion.textoGenericoPickup = instalacionField.textoGenericoPickup
      myInstalacion.textoGenericoMembresia = instalacionField.textoGenericoMembresia
      myInstalacion.labelDeliveryBonificado =
        instalacionField.labelDeliveryBonificado || 'Delivery bonificado en compras superiores a '
      myInstalacion.labelFormaPago =
        instalacionField.labelFormaPago || 'Para abonar con Billetera Santa Fe, MODO o Mercado Pago, seleccionar la opción'
      myInstalacion.labelDescripcionPickup = instalacionField.labelDescripcionPickup || 'retiro del pedido por sucursal'
      myInstalacion.labelDescripcionDelivery = instalacionField.labelDescripcionDelivery || 'envíos a domicilio'
      myInstalacion.basesYCondiciones = instalacionField.basesYCondiciones
      myInstalacion.afipDataFiscalURL = instalacionField.afipDataFiscalURL
      myInstalacion.logoLoginOnline = instalacionField.fondoLogin || undefined

      // datos de contacto
      myInstalacion.datosContacto = {}
      myInstalacion.datosContacto.id =
        instalacionField.datosContacto.idDatosContacto

      if (instalacionField.datosContacto.idDatosContacto !== 0) {
        myInstalacion.datosContacto.id =
          instalacionField.datosContacto.idDatosContacto
        myInstalacion.datosContacto.calle =
          instalacionField.datosContacto.calle || undefined
        myInstalacion.datosContacto.numero =
          instalacionField.datosContacto.numero
        myInstalacion.datosContacto.piso = instalacionField.datosContacto.piso
        myInstalacion.datosContacto.departamento =
          instalacionField.datosContacto.departamento
        myInstalacion.datosContacto.email =
          instalacionField.datosContacto.correo || undefined
        myInstalacion.datosContacto.telefono =
          instalacionField.datosContacto.telefono || undefined
        myInstalacion.datosContacto.facebook =
          instalacionField.datosContacto.facebook || undefined
        myInstalacion.datosContacto.twitter =
          instalacionField.datosContacto.twitter || undefined
        myInstalacion.datosContacto.instagram =
          instalacionField.datosContacto.instagram || undefined
        myInstalacion.datosContacto.tiktok =
          instalacionField.datosContacto.tikTok || undefined
      }

      myInstalacion.rubroTextil = instalacionField.rubroTextil
      myInstalacion.mostrarPrecioSugerido =
        instalacionField.mostrarPrecioSugerido
      myInstalacion.porcentajePrecioSugerido =
        instalacionField.porcentajePrecioSugerido
      myInstalacion.promosBandaDescuentos =
        instalacionField.promosBandaDescuentos
      myInstalacion.bandaDescuento = instalacionField.bandaDescuento

      myInstalacion.montoCompraMinimoPermitido =
        instalacionField.montoCompraMinimoPermitido
      myInstalacion.cobroDelivery = instalacionField.cobroDelivery
      myInstalacion.montoDelivery = instalacionField.montoDelivery
      myInstalacion.deliveryBonificado = instalacionField.deliveryBonificado
      myInstalacion.montoDeliveryBonificado =
        instalacionField.montoDeliveryBonificado

      //parametros tiempo control de actividad del usuario
      myInstalacion.tiempoActividadDelUsuario =
        instalacionField.tiempoActividadDelUsuario
      myInstalacion.tiempoDecisionPedidoBorrador =
        instalacionField.tiempoDelAvisoControlActividadDelUsuario

      myInstalacion.ocultarProductosAgotados =
        instalacionField.ocultarProductosAgotados

      let listaBandaDescuento = []

      instalacionField.listaBandaDescuento.forEach((bd) => {
        let bandaDescuento = {}

        bandaDescuento.idBandaDescuento = bd.idBandaDescuento
        bandaDescuento.idBandaDescuentoPorcentaje =
          bd.idBandaDescuentoPorcentaje
        bandaDescuento.nombre = bd.nombre
        bandaDescuento.limiteInferior = bd.limiteInferior
        bandaDescuento.limiteSuperior = bd.limiteSuperior
        bandaDescuento.porcentajeDescuento = bd.porcentajeDescuento

        listaBandaDescuento.push(bandaDescuento)
      })

      myInstalacion.listaBandaDescuento = listaBandaDescuento
    } else {
      myInstalacion.id = 3
    }
    return myInstalacion
  }
)

const sessionReducerResultadoAutenticacionSelector = (state) =>
  state.sessionReducer.getIn(['resultadoAutenticacion'])
export const resultadoAutenticacionSelector = createSelector(
  sessionReducerResultadoAutenticacionSelector,
  (resultadoAutenticacionField) => {
    return resultadoAutenticacionField.toJS()
  }
)

const sessionReducerUsuarioSelector = (state) =>
  state.sessionReducer.getIn(['usuario'])
export const usuarioSelector = createSelector(
  sessionReducerUsuarioSelector,
  (usuarioField) => {
    let myUsuario = undefined
    if (usuarioField) {
      let usuario = usuarioField.toJS()
      myUsuario = {}
      myUsuario.id = usuario.idUsuario
      myUsuario.nombreUsuario = usuario.nombreUsuario
      myUsuario.idCliente = usuario.idCliente
      myUsuario.idRol = usuario.idRol
      myUsuario.sucursales = usuario.sucursales
    }

    return myUsuario
  }
)

const sessionReducerSucursalSelector = (state) =>
  state.sessionReducer.getIn(['sucursal'])
export const sucursalSelector = createSelector(
  sessionReducerSucursalSelector,
  (sucursalField) => {
    return sucursalField
  }
)

const sessionReducerUsuarioAnonimoSelector = (state) =>
  state.sessionReducer.getIn(['permiteUsuarioAnonimo'])
export const permiteUsuarioAnonimoSelector = createSelector(
  sessionReducerUsuarioAnonimoSelector,
  (usuarioAnonimoField) => {
    return usuarioAnonimoField.toJS()
  }
)

const sessionReducerEstilosInternoSelector = (state) =>
  state.sessionReducer.get('estilosInterno')

const sessionReducerEstilosOnlineSelector = (state) =>
  state.sessionReducer.get('estilosOnline')

export const estilosInternoSelector = createSelector(
  sessionReducerEstilosInternoSelector,
  (estilosInterno) => estilosInterno && estilosInterno.toJS()
)

export const estilosOnlineSelector = createSelector(
  sessionReducerEstilosOnlineSelector,
  (estilosOnline) => estilosOnline && estilosOnline.toJS()
)
